//  1. SASS IMPORTS
//--------------------------------------------------------------------//
//  •   webpack requires import of main sass file as the 
//		entry point to compile sass
//--------------------------------------------------------------------//
import "../scss/style.scss";

//--------------------------------------------------------------------//
//  2. FONTAWESOME ICONS
//--------------------------------------------------------------------//
// import { library, dom } from '@fortawesome/fontawesome-svg-core'; // CORE PACKAGE (REQUIRED)
//--------------------------------------------------------------------//
//  FONTAWESOME CUSTOM KIT PACKAGE (PREFERRED IMPLEMENATION)
//  •   By default, FEBP comes with a basic FontAwesome kit package specific to 
//      the FE Boilerplate in order to verify the implementation works
//  •   Create a new kit for your project by logging to FA, clicking on 
//      "Your Kits", and then "Add New Kit"
//  •   Once your new kit is created, Install kit package into the project using 
//      `npm install --save '@awesome.me/kit-KIT_CODE@latest'`, 
//      replacing "KIT_CODE" with the kit's ID which can be found on the kit's 
//      "Package" tab within the kit on FA
//--------------------------------------------------------------------//
// import { all } from '@awesome.me/kit-64564bfa37/icons';
// library.add(...all);
//--------------------------------------------------------------------//
//  FONTAWESOME DEFAULT ICON PACKAGES (DO NOT USE IN PRODUCTION)
//  •   To use full default icon packages, comment out the Custom Kit's package import 
//      and library.add() from the Kit Package section above
//  •   Uncomment any icon packages you want to use
//  •   Ucomment library.add() in this section and update the array with the 
//      only the icon namespaces you'll be using
// import { fadl } from "@fortawesome/duotone-light-svg-icons";
// import { fadr } from "@fortawesome/duotone-regular-svg-icons";
// import { fadt } from "@fortawesome/duotone-thin-svg-icons";
// import { fab } from "@fortawesome/free-brands-svg-icons";
// import { fad } from "@fortawesome/pro-duotone-svg-icons";
// import { fal } from "@fortawesome/pro-light-svg-icons";
// import { far } from "@fortawesome/pro-regular-svg-icons";
// import { fas } from "@fortawesome/pro-solid-svg-icons";
// import { fat } from "@fortawesome/pro-thin-svg-icons";
// import { fasdl } from "@fortawesome/sharp-duotone-light-svg-icons";
// import { fasdr } from "@fortawesome/sharp-duotone-regular-svg-icons";
// import { fasds } from "@fortawesome/sharp-duotone-solid-svg-icons";
// import { fasdt } from "@fortawesome/sharp-duotone-thin-svg-icons";
// import { fasl } from "@fortawesome/sharp-light-svg-icons";
// import { fasr } from "@fortawesome/sharp-regular-svg-icons";
// import { fass } from "@fortawesome/sharp-solid-svg-icons";
// import { fast } from "@fortawesome/sharp-thin-svg-icons";
// library.add(fadl, fadr, fadt, fab, fad, fal, far, fas, fat, fasdl, fasdr, fasds, fasdt, fasl, fasr, fass, fast);
//--------------------------------------------------------------------//
// dom.watch(); // REQUIRED - Converts i tags to SVG

//--------------------------------------------------------------------//
//  3. JAVASCRIPT IMPORTS
//--------------------------------------------------------------------//
//  •   Add files to bundles to concatenate and minify them into a 
//      single file
//  •   If you add a new bundle, add a new task and add the task to the
//      `scripts` task
//

//--------------------------------------------------------------------//
//  ASCEDIA UI
//--------------------------------------------------------------------//
import { defineCustomElements } from '@ascedia/ui'; // Ascedia UI Component Library
defineCustomElements();
//--------------------------------------------------------------------//
//  BOOTSTRAP
//--------------------------------------------------------------------//
import 'bootstrap'; // Bootstrap CSS Framework
//--------------------------------------------------------------------//
// GSAP - INCLUDES BUSINESS LICENSE
//--------------------------------------------------------------------//
// import { gsap } from "gsap";
// import { CustomEase } from "gsap/CustomEase";
// import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";
// import { CustomBounce } from "gsap/CustomBounce"; // extends CustomEase
// import { CustomWiggle } from "gsap/CustomWiggle"; // extends CustomEase
// import { Flip } from "gsap/Flip";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { Draggable } from "gsap/Draggable";
// import { MotionPathPlugin } from "gsap/MotionPathPlugin";
// import { EaselPlugin } from "gsap/EaselPlugin";
// import { PixiPlugin } from "gsap/PixiPlugin";
// import { TextPlugin } from "gsap/TextPlugin";
// import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// import { GSDevTools } from "gsap/GSDevTools";
// import { InertiaPlugin } from "gsap/InertiaPlugin";
// import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
// import { MotionPathHelper } from "gsap/MotionPathHelper";
// import { Physics2DPlugin } from "gsap/Physics2DPlugin";
// import { PhysicsPropsPlugin } from "gsap/PhysicsPropsPlugin";
// import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
// import { SplitText } from "gsap/SplitText";

// gsap.registerPlugin(Flip,ScrollTrigger,Observer,ScrollToPlugin,Draggable,MotionPathPlugin,EaselPlugin,PixiPlugin,TextPlugin,DrawSVGPlugin,ScrollSmoother,GSDevTools,InertiaPlugin,MorphSVGPlugin,MotionPathHelper,Physics2DPlugin,PhysicsPropsPlugin,ScrambleTextPlugin,SplitText,RoughEase,ExpoScaleEase,SlowMo,CustomEase,CustomBounce,CustomWiggle);
//--------------------------------------------------------------------//
//  VENDOR LIBRARIES / PLUGINS (OPTIONAL)
//--------------------------------------------------------------------//
// import 'masonry-layout'; // Masonry Layout using Bootstrap Grid
import { register } from 'swiper/element/bundle'; // Swiper Slider
register(); // register Swiper custom elements
// import 'dayjs'; // Day.JS (Alt to Moment.js) 
//--------------------------------------------------------------------//
//  ANIMATION LIBRARIES
//--------------------------------------------------------------------//
// import 'aos'; // Animate On Scroll
//--------------------------------------------------------------------//
// ELEMENTS GSAP ANIMATION UTILITIES (optional)
//--------------------------------------------------------------------//
// import * as gsapAnimations from "scripts/modules/animation"
//--------------------------------------------------------------------//
//  GLOBAL SITE JAVASCRIPT (should always be last)
//  •   Imports should use the resolve alias `scripts` at the begin of each import file path 
//      •   `scripts` = [Directory Name]/[root]/src/scripts
//--------------------------------------------------------------------//
import * as utils from "scripts/modules/utilities";
//
//
//
//
//
//
document.addEventListener('DOMContentLoaded', () => {
	// Bootstrap matching Media Queries
    // To use:
    //      Pass mediaQueries into module function: [Import Name].function(mediaQueries)
    //      In module function:
    //          if(mediaQueries.sm.matches){
    //              code here
    //          }

	const mediaQueries = {
        sm: window.matchMedia('(min-width: 576px)'),
        md: window.matchMedia('(min-width: 768px)'),
        lg: window.matchMedia('(min-width: 992px)'),
        xl: window.matchMedia('(min-width: 1200px)'),
        xxl: window.matchMedia('(min-width: 1400px)')
    }
	//------------------------------------------------------------------------//
	// ELEMENTS ANIMATION UTILITY FUNCTIONS
    //   • In order to use the following animation functions, you must 
    //      - uncomment the GSAP core library and any required plugins
    //      - use `gsap.registerPlugin()` to register any required plugins 
    //         - (modify or create a new method below the GSAP section above in main.js
    //      - uncomment the `gsapAnimations` import near line 102
    //      - Uncomment any or all animation functions below
    //------------------------------------------------------------------------//
    // gsapAnimations.slideUp(gsap);                       // Affects elements with .js-slide-up
    // gsapAnimations.slideLeft(gsap);                     // Affects elements with .js-slide-left
    // gsapAnimations.slideRight(gsap);                    // Affects elements with .js-slide-right
    // gsapAnimations.staggerItems(gsap);                  // Affects elements with .js-stagger-item, wrapped within a .js-stagger-item-contener elmeent
    // gsapAnimations.skewElement(gsap, ScrollTrigger);    // Affects elements with .js-skew-element

    utils.setLeftOffset(mediaQueries);

	//------------------------------------------------------------------------//

    utils.navTopPosition(mediaQueries);

	//------------------------------------------------------------------------//
    //  IMPORT MODULE FUNCTIONS
    //------------------------------------------------------------------------//
    //  Usage Examples: 
    //      [Import Namespace].functionName();
    //      [Import Namespace].functionName(mediaQueries);
    //------------------------------------------------------------------------//

    //------------------------------------------------------------------------//
    // MEDIA QUERY IMPORT MODULE FUNCTIONS
    // •   To use a query, comment out `return null;` and a function
    // •   Usage Examples: 
    //          [Import Namespace].functionName();
    //          [Import Namespace].functionName(mediaQuery);
    //------------------------------------------------------------------------//
    const mediaQueryFunctions = {
        sm: () => {
            return null;
        },
        md : () => {
            return null;
        },
        lg : () => {
            return null;
        },
        xl : () => {
            return null;
        },
        xxl : () => {
            return null;
        }
    }

    window.addEventListener('resize', () => {
        utils.setLeftOffset(mediaQueries);
        utils.navTopPosition(mediaQueries);
    })    

    //------------------------------------------------------------------------//
    // MEDIA QUERY RESIZE LISTENER
    //------------------------------------------------------------------------//
    for(let mediaQuery in mediaQueries) {
        if(mediaQueryFunctions[mediaQuery] != null) {
            mediaQueries[mediaQuery].addEventListener("change", () => {
                mediaQueryFunctions[mediaQuery]();
            })
        }
    }

    //------------------------------------------------------------------------//
    //  DYNAMIC IMPORTED MODULE FUNCTIONS
    //------------------------------------------------------------------------//
    (() => {
        const loadModules = document.querySelectorAll('[data-load-module]');
    
        loadModules.forEach(async module => {
            const loadModule = module.dataset.loadModule;
            const loadType = module.dataset.loadType;
            const moduleFile = await import(`scripts/modules/${loadModule}`);
            const moduleFunctions = Object.entries(moduleFile);
            const indexOfModuleFunction = moduleFunctions.findIndex(x => x[0] == "import" + capitalize(loadModule));
            const moduleFunction = moduleFunctions[indexOfModuleFunction][1];
            moduleFunction(loadType, module);
        });

        const capitalize = (string) => {
            return string.split('-').map((word) => {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join('');
        }
    })();


    

}, false);